import "@mantine/code-highlight/styles.css";

import { Box } from "@mantine/core";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Shiki } from "shared/components/shiki";
import { isSupport } from "shared/hooks/useIsSupport";
import { match } from "ts-pattern";

function DevRibbon(props: { pos: "top" | "bottom" }) {
    const positioning = match(props.pos)
        .with("top", () => ({ top: 0 }))
        .with("bottom", () => ({ bottom: 0 }))
        .exhaustive();

    return (
        <Box
            style={{
                position: "fixed",
                left: 0,
                width: "100%",
                height: "8px",
                background: "repeating-linear-gradient(45deg, yellow, yellow 10px, black 10px, black 20px)",
                zIndex: 9999,
                ...positioning,
            }}
        />
    );
}
const Layout = () => {
    return (
        <Shiki.Provider>
            <DevRibbon pos="top" />
            <Outlet />
            <DevRibbon pos="bottom" />
        </Shiki.Provider>
    );
};

/** @public */
export const Route = createFileRoute("/_auth/_dev")({
    beforeLoad: async ({ context: { auth } }) => {
        if (!isSupport(await auth) && import.meta.env.VITE_ENVIRONMENT != "local") throw redirect({ to: "/" });
    },
    component: Layout,
});
